const Questionaire = () => {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_diii_27669_18585)">
        <g clipPath="url(#clip0_27669_18585)">
          <path
            d="M8 36C8 18.3269 22.3269 4 40 4C57.6731 4 72 18.3269 72 36C72 53.6731 57.6731 68 40 68C22.3269 68 8 53.6731 8 36Z"
            fill="#225AEA"
          />
          <rect x="8" y="4" width="64" height="64" rx="32" fill="url(#paint0_linear_27669_18585)" />
          <g opacity="0.4">
            <path
              d="M32.7018 12.6766C32.3354 11.3118 30.9258 10.4894 29.6042 10.9902C23.6097 13.2587 18.6842 17.6932 15.801 23.4174C15.1642 24.6814 15.8346 26.1694 17.1546 26.675C18.4746 27.1822 19.9418 26.5134 20.6106 25.267C22.8639 21.0577 26.5171 17.7678 30.9386 15.9662C32.249 15.4318 33.0666 14.043 32.7018 12.6782V12.6766Z"
              fill="#F2F6FF"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.9999 24.3333C33.5566 24.3333 28.3333 29.5566 28.3333 35.9999C28.3333 42.4432 33.5566 47.6666 39.9999 47.6666C46.4432 47.6666 51.6666 42.4432 51.6666 35.9999C51.6666 29.5566 46.4432 24.3333 39.9999 24.3333ZM39.9999 32.4999C39.5597 32.4999 39.1747 32.7433 38.975 33.1084C38.6658 33.6737 37.9569 33.8813 37.3916 33.5721C36.8263 33.2629 36.6187 32.554 36.9279 31.9887C37.5203 30.9054 38.673 30.1666 39.9999 30.1666C41.7671 30.1666 42.9946 31.3407 43.3441 32.7204C43.6954 34.1074 43.1617 35.7234 41.5652 36.5217C41.3209 36.6438 41.1666 36.8935 41.1666 37.1666C41.1666 37.8109 40.6443 38.3333 39.9999 38.3333C39.3556 38.3333 38.8333 37.8109 38.8333 37.1666C38.8333 36.0097 39.4869 34.9521 40.5217 34.4347C41.0522 34.1694 41.1885 33.7129 41.0822 33.2934C40.9741 32.8665 40.6163 32.4999 39.9999 32.4999ZM39.9999 41.8333C40.6443 41.8333 41.1666 41.3109 41.1666 40.6666C41.1666 40.0223 40.6443 39.4999 39.9999 39.4999C39.3556 39.4999 38.8333 40.0223 38.8333 40.6666C38.8333 41.3109 39.3556 41.8333 39.9999 41.8333Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_diii_27669_18585"
          x="-9.53674e-07"
          y="-4"
          width="80"
          height="84"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_27669_18585" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_27669_18585"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="-4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_27669_18585" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_27669_18585"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.113725 0 0 0 0 0.309804 0 0 0 0 0.843137 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_27669_18585"
            result="effect3_innerShadow_27669_18585"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-8" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.862745 0 0 0 0 0.917647 0 0 0 0 0.996078 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_innerShadow_27669_18585"
            result="effect4_innerShadow_27669_18585"
          />
        </filter>
        <linearGradient
          id="paint0_linear_27669_18585"
          x1="40"
          y1="4"
          x2="40"
          y2="68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.16" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_27669_18585">
          <path
            d="M8 36C8 18.3269 22.3269 4 40 4C57.6731 4 72 18.3269 72 36C72 53.6731 57.6731 68 40 68C22.3269 68 8 53.6731 8 36Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Questionaire
